import { LW_REFINE_FILTER_KEY_VALUE_DELIMITER } from '@/constants/index';
import { isBDSite } from '@/services/search/utils';

import { grsBooleanValueFacets, grsRangeValueFacets } from './grs.constants';

export const GRS_ATTRIBUTE_FACET_KEY_PREFIX = 'attributes.';
export const LW_ATTRIBUTE_FACET_KEY_SUFFIX = '_attr';

export const LW_CATEGORY_FACET_KEY = 'item_category';
export const GRS_CATEGORY_FACET_KEY = 'attributes.category_info';

export const LW_TWO_DAY_FACET_KEY = 'item_program_eligibility';
export const GRS_TWO_DAY_FACET_KEY = 'attributes.program_types';
export const TWO_DAY_FACET_VALUE = '2DayDelivery';

export const LW_DELIVERY_FACET_KEY = 'item_program_eligibility';
export const GRS_DELIVERY_FACET_KEY = 'attributes.program_types';
export const DELIVERY_FACET_VALUE = 'ShipIt';

export const LW_BOPIM_FACET_KEY = 'item_location_bopim';
export const GRS_BOPIM_FACET_KEY = 'mdo_pickup';

export const LW_BUY_IN_WAREHOUSE_FACET_KEY = 'item_program_eligibility';
export const GRS_BUY_IN_WAREHOUSE_FACET_KEY = 'buy_in_warehouse';
export const BUY_IN_WAREHOUSE_FACET_VALUE = 'InWarehouse';

export const LW_BOPIW_FACET_KEY = 'item_location_bopiw';
export const GRS_BOPIW_FACET_KEY = 'warehouse_pickup';

export const LW_SHOW_OUT_OF_STOCK_FACET_KEY = 'item_location_availability';
export const LW_SHOW_OUT_OF_STOCK_FACET_VALUE = 'in stock';
export const LW_OUT_OF_STOCK_QUERY_PARAM_VALUE = 'out of stock';
export const GRS_SHOW_OUT_OF_STOCK_FACET_KEY = 'show_out_of_stock';

export const LW_PRICE_FACET_KEY = 'item_location_pricing_salePrice';
export const GRS_US_PRICE_FACET_KEY = 'inventory(847, price)';
export const GRS_CA_PRICE_FACET_KEY = 'inventory(894, price)';

export const LW_RATING_FACET_KEY = 'item_rating_value';
export const GRS_RATING_FACET_KEY = 'rating';

export const LW_BRANDS_FACET_KEY = 'Brand_attr';
export const GRS_BRANDS_FACET_KEY = 'brands';

export const DEFAULT_REFINEMENT_FILTER_PAIRS = isBDSite(
    process.env.NEXT_PUBLIC_SITE,
)
    ? []
    : [
          `${LW_DELIVERY_FACET_KEY}${LW_REFINE_FILTER_KEY_VALUE_DELIMITER}${DELIVERY_FACET_VALUE}`,
      ];

export const NEGATION_REFINEMENT_FILTER_PAIRS = ['']; // empty string to avoid typescript error in utils file

export const GRS_STANDARD_REFINEMENT_FILTER_KEYS = [
    GRS_DELIVERY_FACET_KEY,
    GRS_TWO_DAY_FACET_KEY,
    GRS_BUY_IN_WAREHOUSE_FACET_KEY,
    GRS_SHOW_OUT_OF_STOCK_FACET_KEY,
    GRS_BOPIW_FACET_KEY,
    GRS_BOPIM_FACET_KEY,
    GRS_CA_PRICE_FACET_KEY,
    GRS_US_PRICE_FACET_KEY,
];

export const LW_STANDARD_REFINEMENT_FILTER_KEYS = [
    LW_DELIVERY_FACET_KEY,
    LW_TWO_DAY_FACET_KEY,
    LW_BUY_IN_WAREHOUSE_FACET_KEY,
    LW_SHOW_OUT_OF_STOCK_FACET_KEY,
    LW_BOPIW_FACET_KEY,
    LW_BOPIM_FACET_KEY,
    LW_PRICE_FACET_KEY,
];

export const STANDARD_REFINEMENT_FILTER_KEYS = [
    ...GRS_STANDARD_REFINEMENT_FILTER_KEYS,
    ...LW_STANDARD_REFINEMENT_FILTER_KEYS,
];

export const FACET_CS_DEV_KEY = 'search-facets';
export const BUTTON_SET_DEV_KEY = 'button_set';
export const RATING_LABEL_VALUE_KEY = 'ratinglabelvalue';
export const RATING_TAG_LABEL_KEY = 'ratingtaglabel';
export const RATING_LABEL_DISPLAY_KEY = 'ratinglabeldisplaytext';
export const PRICE_LABEL_KEY = 'pricelabel';

export const DELIVERY_TEXT_KEY = 'facetlabel.shipit';
export const LIST_TITLE_KEY = 'filtertitle';
export const OUT_OF_STOCK_TEXT_KEY = 'facetlabel.outofstock';
export const PICK_UP_TEXT_KEY = 'facetlabel.pickup';
export const TWO_DAY_DELIVERY_TEXT_KEY = 'facetlabel.2daydelivery';
export const BUY_IN_WAREHOUSE_TEXT_KEY = 'facetlabel.inwarehouse';

export const COSTCOGROCERY_FACET_KEY = 'facetlabel.costcogrocery';

export const OUT_OF_STOCK_BUCKET_VALUE = 'in stock';
export const IN_WAREHOUSE_BUCKET_VALUE = 'inwarehouse';

export const REFINE_QUERY_PARAM = 'refine';
export const LW_REFINE_QUERY_PARAM = REFINE_QUERY_PARAM;
export const GRS_REFINE_QUERY_PARAM = 'refinement';

export const A11Y_FILTER_KEY = 'a11y.searchfacetsreloadtext';
export const A11Y_FILTER_DESCRIBED_BY = 'a11y_facet_warning';
export const CURRENT_PAGE = 'currentPage';

export const FACET_OPTION_SELECTED_FILTER = 'facet_option_sf_';
export const SELECTED_FACETS = 'selectedFacets';

// These are for future refactor and not used right now. Empty for that reason.
export const lwRangeValueFacets = [
    // LW_PRICE_FACET_KEY,
    // LW_RATING_FACET_KEY,
];
// These are for future refactor and not used right now. Empty for that reason.
export const lwBooleanValueFacets = [
    LW_BOPIM_FACET_KEY,
    LW_BOPIW_FACET_KEY,
    // LW_BUY_IN_WAREHOUSE_FACET_KEY,
    // LW_SHOW_OUT_OF_STOCK_FACET_KEY,
    // LW_WAREHOUSE_PICKUP_FACET_KEY,
];

export const rangeValueFacets = [...lwRangeValueFacets, ...grsRangeValueFacets];
export const booleanValueFacets = [
    ...lwBooleanValueFacets,
    ...grsBooleanValueFacets,
];
